import { createContext, useEffect, useState } from "react";
import * as React from "react";
import { useLocation, useParams } from "react-router-dom";

export const SignsOverlayContext = createContext({
	saveInspectionHandler: null,
	setSaveInspectionHandler: null,
});
const SignsOverlayContextProvider = ({ children }) => {
	const [signsOverlayHandler, setSignsOverlayHandler] = useState(null);

	return (
		<SignsOverlayContext.Provider value={{ signsOverlayHandler, setSignsOverlayHandler }}>
			{children}
		</SignsOverlayContext.Provider>
	);
};
export default SignsOverlayContextProvider;
